import { Link, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import BlockCalendarView from '../components/training/BlockCalendarView';

export default function BlockCalendarPage() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const focusBlockId = searchParams.get('blockId');

  return (
    <div className='mx-auto max-w-[95vw] space-y-4 p-4 md:p-6'>
      <div className='flex flex-wrap items-center gap-3'>
        <Button variant='ghost' size='sm' asChild>
          <Link to='/training-plan/design'>
            <ArrowLeft className='mr-1 h-4 w-4' />
            {t('periodization.designTitle')}
          </Link>
        </Button>
        <h1 className='text-xl font-semibold'>{t('periodization.calendar.title')}</h1>
      </div>

      <BlockCalendarView focusBlockId={focusBlockId} linkBlocksToDesign />
    </div>
  );
}
